<template>
  <div :class="{ 'functionary-shell': profile === 'functionary' }">
    <nav class="navbar is-fixed-top box-shadow-y" :class="profile === 'functionary' ? 'functionary-navbar' : 'has-background-primary'" :shadow="true">
      <div class="navbar-brand has-text-centered">
        <a href="#" class="navbar-item has-text-weight-bold has-text-white" :class="{ 'has-background-primary': profile !== 'functionary' }">ENCUESTAS</a>
        <a @click="showMenu = !showMenu" role="button" :class="showMenu ? 'navbar-burger is-active' : 'navbar-burger'" style="color: white" aria-label="Menú" :aria-expanded="showMenu.toString()">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" :class="{ 'has-background-primary': profile !== 'functionary', 'is-active': showMenu }">
        <div class="navbar-start">  
        </div>

        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable has-text-black">
            <a href="#" class="navbar-link has-text-white" >
              <i class="fa fa-user icon has-text-white"></i> 
              {{ userName || 'Mi cuenta' }}
            </a>
            <div class="navbar-dropdown is-right" >
              <a class="navbar-item"  @click="closeSession()">Cerrar sesión</a>
            </div>
          </div>
        </div>
      </div>
      
    </nav>
    <div>
     
      <div class="columns is-variable is-0">
        <div>
          <div class="menu-container px-1 show-menu" :class="{ 'has-background-dark': profile !== 'functionary', 'functionary-menu': profile === 'functionary', active: showMenu }">
            <div class="menu-wrapper py-1">
              <aside class="menu">
                <side-menu-administrative v-if="profile == 'administrative'"></side-menu-administrative>
                <SideMenuFunctionary v-if="profile == 'functionary'"></SideMenuFunctionary>
                <!-- <side-menu-collector v-if="profile == 'collector'"></side-menu-collector>
                <side-menu-laboratory v-if="profile == 'laboratory'"></side-menu-laboratory>
                <side-menu-notificator v-if="profile == 'notificator'"></side-menu-notificator>
                <side-menu-assistant v-if="profile == 'assistant'"></side-menu-assistant>
                <side-menu-manager v-if="profile == 'manager'"></side-menu-manager>
                <side-menu-consult-medic v-if="profile == 'consult_medic'"></side-menu-consult-medic> -->
                <p class="menu-label has-text-light has-text-centered" :style="profile === 'functionary' ? null : { backgroundColor: '#1a2226' }">Acciones</p>
                <ul class="menu-list">

                  <li>
                    <a class="has-text-white" @click="closeSession()">
                      <i class="fas fa-info-circle icon"></i>
                      Cerrar sesión
                    </a>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div>
         <EditProfile
          v-if="profile !== 'functionary' && isComponentEditActive"
          :isComponentEditActive="isComponentEditActive"
          :closeEdit="closeEdit"
          :nameUserConnect="nameUserConnect"
          :user_id="user_id"
        ></EditProfile>
           <changePass
          v-if="isComponentPassActive"
          :isComponentPassActive="isComponentPassActive"
          :closeEditPassword="closeEditPassword"
          :user_id="user_id"
        ></changePass>
        <div class="column is-10-desktop is-offset-2-desktop is-9-tablet is-offset-3-tablet is-12-mobile" >
          <div class="p-1">
            <div class="columns is-variable is-desktop">
              <div class="column">
                <br><br>
                <h1 class="title">
                  <slot name="titulo"></slot>
                </h1>
                        
              </div>

            </div>
                    <slot name="breadCrumb"></slot>

                <br>
        
          
            <div class="columns is-variable">
              <div class="column is-12-desktop is-12-tablet">
                <div v-if="showProfile" class="card profile-card">
                  <div class="card-content">
                    <div class="profile-topline">
                      <span class="profile-label">Mi perfil</span>
                      <span class="profile-date">{{ fecha }}</span>
                    </div>
                    <div class="profile-main">
                      <div class="profile-avatar" aria-hidden="true">{{ initials }}</div>
                      <div class="profile-identity">
                        <span class="profile-role">{{ profile === 'functionary' ? 'Funcionario' : 'Administración' }}</span>
                        <h2>{{ userName || 'Usuario' }}</h2>
                        <p>Información de tu cuenta</p>
                      </div>
                    </div>
                    <div class="profile-details">
                      <div><span>RUT</span><strong>{{ displayedRut }}</strong></div>
                      <div><span>Correo electrónico</span><strong>{{ email.email || 'No registrado' }}</strong></div>
                      <div v-if="establishmentName"><span>Establecimiento</span><strong>{{ establishmentName }}</strong></div>
                    </div>
                    <p v-if="profile === 'functionary'" class="profile-readonly-note">Los datos del perfil son de solo lectura.</p>
                    <div class="profile-actions">
                      <button v-if="profile !== 'functionary'" class="button is-primary" type="button" :disabled="!email.id" @click="openEdit(email.id)">
                        <b-icon pack="fas" icon="user" size="is-small"></b-icon><span>Editar perfil</span>
                      </button>
                      <button class="button is-light" type="button" :disabled="!email.id" @click="openPass(email.id)">
                        <b-icon pack="fas" icon="key" size="is-small"></b-icon><span>Cambiar contraseña</span>
                      </button>
                    </div>
                  </div>
                </div>
              <br v-if="showProfile">
                <slot name="contenido"></slot>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReLogin from "./../components/ReLogin";
import EditProfile from "../components/EditProfile";
import changePass from "../components/changePass";
import SideMenuAdministrative from "./../views/administrative/SideMenu";
import SideMenuFunctionary from "./../views/functionary/SideMenu";
// import SideMenuSupervisor from "./../views/supervisor/SideMenu";
// import SideMenuLaboratory from "./../views/laboratory/SideMenu";
// import SideMenuNotificator from "./../views/notificator/SideMenu";
// import SideMenuAssistant from "@/views/assistant/SideMenu";
// import SideMenuManager from "@/views/manager/SideMenu";
// import SideMenuConsultMedic from "@/views/consultant/SideMenu";

import { eventBus } from "../main";
import { formatRut } from "../utils/rut";

export default {
  name: "PlantillaContenido",
  props: {
    showProfile: { type: Boolean, default: true },
  },
  components: {
    EditProfile: EditProfile,
    changePass:changePass,
    SideMenuAdministrative,
    SideMenuFunctionary,
    // SideMenuCollector,
    // SideMenuSupervisor,
    // SideMenuLaboratory,
    // SideMenuNotificator,
    // SideMenuAssistant,
    // SideMenuManager,
    // SideMenuConsultMedic
  },
  data() {
    return {
      open: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: false,
      profile: window.localStorage.getItem("perfil") || "",
      detectedError: null,
      userName: "Cargando ...",
      email: {},
      fecha:'',
      isModalReloginShown: false,
      isComponentEditActive: false,
      user_id:'',
      isComponentPassActive: false,
      stablishment:'',
      showMenu: false
    };
  },
  computed: {
    initials() {
      return (this.userName || 'Usuario').trim().split(/\s+/).slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('');
    },
    displayedRut() {
      return this.email.rut ? formatRut(this.email.rut) : 'No registrado';
    },
    establishmentName() {
      const establishment = this.email.stablishment;
      return establishment && (establishment.name || (typeof establishment === 'string' ? establishment : ''));
    },
  },
  mounted() {
    eventBus.$on("value", this.onSessionExpired);
    this.profile = window.localStorage.getItem("perfil");
  },
  beforeDestroy() {
    eventBus.$off("value", this.onSessionExpired);
  },
  created: function () {
    this.nameUserConnect();
  },
  methods: {
    onSessionExpired() {
      if (!window.localStorage.getItem("token") || this.$route.name === "Login" || this.$route.name === "login" || this.isModalReloginShown) return;
      this.isModalReloginShown = true;
      this.$buefy.modal.open({
        parent: this,
        component: ReLogin,
        hasModalCard: true,
        trapFocus: true,
        canCancel: false
      });
    },
    openMenu: function () {
      this.open = true;
    },
    closeSession: function () {
      this.$buefy.dialog.confirm({
        title: '¿Está seguro que desea cerrar sesión?',
        message: 'Para continuar presione en cerrar sesión.',
        confirmText: 'Cerrar sesión',
        cancelText: 'Cancelar',
        type: 'is-primary',
        hasIcon: true,
        onConfirm:  () => {
          window.localStorage.removeItem("token")
          window.localStorage.removeItem("user")
          window.localStorage.removeItem("userName")
          window.localStorage.removeItem("perfil")
          this.$router.push({ name: "Login" })
        } 
      })
    },
    closeEdit() {
      this.user_id = null;
      this.isComponentEditActive = false;
    },
       closeEditPassword(){
       this.isComponentPassActive=false;
    },
    
    nameUserConnect: function () {
      this.fecha = new Intl.DateTimeFormat('es-CL', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date());
      this.userName = window.localStorage.getItem("userName") || '';
      this.email = JSON.parse(window.localStorage.getItem("user") || '{}') || {};
    },
    openEdit:function(id) {
      if (this.profile === 'functionary') return;
      this.user_id = id,
      this.isComponentEditActive= true
    },
    openPass:function(id) {
      this.user_id = id,
      this.isComponentPassActive= true
    },
  },
};
</script>


<style >
.functionary-shell { min-height: 100vh; background-color: #f4f8f7; }
.functionary-shell .functionary-navbar,
.functionary-shell .functionary-navbar .navbar-menu,
.functionary-shell .functionary-navbar .navbar-brand > .navbar-item { background-color: #155762; }
.functionary-shell .functionary-navbar .navbar-brand > .navbar-item:hover,
.functionary-shell .functionary-navbar .navbar-brand > .navbar-item:focus,
.functionary-shell .functionary-navbar .navbar-link:hover,
.functionary-shell .functionary-navbar .navbar-link:focus,
.functionary-shell .functionary-navbar .navbar-item.has-dropdown:hover .navbar-link { background-color: #1c6c74; color: white; }
.functionary-shell .functionary-navbar .navbar-item.has-dropdown:hover { background-color: #1c6c74; }
.functionary-shell h1.title { color: #24464c; }
.functionary-shell .breadcrumb a { color: #147970; }
.functionary-shell .functionary-menu { background-color: #103f4b; }
.functionary-shell .functionary-menu .menu-label { margin: .7rem 0; padding: .55rem .7rem; border-radius: 7px; background-color: #0b3540; color: #bde5dc; font-weight: 700; letter-spacing: .08em; }
.functionary-shell .functionary-menu .menu-list a { border-radius: 8px; color: white; }
.functionary-shell .functionary-menu .menu-list a:hover,
.functionary-shell .functionary-menu .menu-list a:focus { background-color: #1a626b; color: white; }
.functionary-shell .functionary-menu .menu-list a.is-active { background-color: #087b72; color: white; font-weight: 700; }
.functionary-shell .button.is-primary { border-color: #087b72; background-color: #087b72; color: white; }
.functionary-shell .button.is-primary:hover,
.functionary-shell .button.is-primary:focus { border-color: #06655e; background-color: #06655e; color: white; }
.functionary-shell .button.is-primary:focus-visible { box-shadow: 0 0 0 3px rgba(8, 123, 114, .25); }
.profile-card { border: 1px solid #e4eceb; border-radius: 16px; overflow: hidden; box-shadow: 0 12px 30px rgba(30, 69, 70, .07); }
.profile-card .card-content { padding: clamp(1.3rem, 3vw, 2rem); }
.profile-topline, .profile-main, .profile-actions { display: flex; align-items: center; }
.profile-topline { justify-content: space-between; gap: 1rem; margin-bottom: 1.4rem; }
.profile-label { color: #145c62; font-size: .77rem; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
.profile-date { color: #728387; font-size: .85rem; }
.profile-main { gap: 1rem; }
.profile-avatar { display: grid; flex: none; place-items: center; width: 4.5rem; height: 4.5rem; border-radius: 18px; background: #dff1e9; color: #176657; font-size: 1.5rem; font-weight: 700; }
.profile-identity { min-width: 0; }
.profile-role { display: inline-block; margin-bottom: .4rem; padding: .2rem .7rem; border-radius: 99px; background: #e8f5ef; color: #176657; font-size: .72rem; font-weight: 700; }
.profile-identity h2 { margin: 0; color: #203d45; font-size: clamp(1.25rem, 2vw, 1.6rem); font-weight: 700; line-height: 1.25; }
.profile-identity p { color: #738287; font-size: .88rem; }
.profile-details { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin: 1.5rem 0; padding: 1.25rem 0; border-top: 1px solid #edf1f0; border-bottom: 1px solid #edf1f0; }
.profile-details div { min-width: 0; }
.profile-details span, .profile-details strong { display: block; }
.profile-details span { margin-bottom: .25rem; color: #738287; font-size: .78rem; }
.profile-details strong { overflow-wrap: anywhere; color: #27464d; font-size: .94rem; font-weight: 600; }
.profile-actions { flex-wrap: wrap; gap: .75rem; }
.profile-readonly-note { margin-bottom: .9rem; color: #607578; font-size: .86rem; }
.profile-actions .button { min-height: 2.65rem; border-radius: 8px; font-weight: 600; }
@media (max-width: 560px) {
  .profile-topline { align-items: flex-start; flex-direction: column; gap: .25rem; }
  .profile-actions { align-items: stretch; flex-direction: column; }
  .profile-actions .button { justify-content: flex-start; width: 100%; }
}
html,
body {
  height: 100%;
  background-color: #efefef;
}

.px-1,
.p-1 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1,
.p-1 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.box-shadow-y {
  -webkit-box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
}

.menu-container {
  position: fixed;
  bottom: 0;
  top: 50px;
  margin: auto;
  min-width: 300px;
  z-index: 10;
  background-color: transparent;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
}

.menu-container.active {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
}

.icon {
  height: 30px;
  width: 30px;
  vertical-align: baseline;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.toggler {
  margin-left: 0;
  cursor: pointer;
}

@media (min-width: 769px) {
  .menu-container {
    width: 25%;
    min-width: auto;
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
}

@media (min-width: 1024px) {
  .menu-container {
    width: 16.6667%;
    min-width: auto;
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
}

/*# sourceMappingURL=style.css.map */
</style>
<style lang="scss">
  @import "~bulma/sass/utilities/_all";
  @import "~vue-wysiwyg/dist/vueWysiwyg.css";
  
  $my-primary: #30bb5c;
  $link: #99cca9;
  $primary-invert: white;
  $pagination-focus-border-color:$my-primary;
  $pagination-current-background-color: $my-primary;
  $menu-item-hover-background-color:#1D292E;
  $navbar-dropdown-arrow:white;
  $menu-label-spacing:1.2em;
  $menu-label-font-size:0.8em;
  $navbar-item-hover-color:black;
  $navbar-item-hover-background-color:black;
  $menu-item-active-background-color:#10171A;
  $datepicker-item-selected-background-color: $my-primary;
  $checkbox-active-background-color: $my-primary;
  $colors: (
    "primary": ($my-primary, $primary-invert),
    "dark":(#222d32, white),
    "success":(#00a65a,white),
    "danger":(#dd4b39,white),
    "warning":(#f39c12,white),
    "light": ($light, $light-invert)
  );

  // Import Bulma and Buefy styles

  @import "~bulma"; 
  @import "~buefy/src/scss/buefy";

</style>
